import type { Label } from "../types";

/**
 * The one look for a guess button, shared by Predict's daily controls
 * (Higher/Lower) and its weekly controls (Green/Red): the direction it stands
 * for is carried by the outline and the text together, in the candle-up /
 * candle-down tokens. A label with no direction stays neutral and takes the
 * accent on hover like every other control.
 *
 * A filled border plus a faint fill (GRA-125), not just an outline: this is
 * the page's primary action, the one decision the whole loop is built
 * around, so it has to read as visually heavier than every quiet bordered
 * control around it, not the same weight as one.
 */
export function directionButtonClass(label: Label): string {
  const base =
    // `min-h-9` below `sm`: the guess buttons are the primary action, so they
    // stay a comfortable 36px tap on a phone, the height every primary action
    // shares there, without the chunkier 44px they used to take.
    "flex min-h-9 min-w-24 items-center justify-center gap-2 rounded border px-4 py-1.5 font-mono text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-40 sm:min-h-6";
  const direction =
    label === "up"
      ? "border-up bg-up/10 text-up hover:bg-up/20"
      : label === "down"
        ? "border-down bg-down/10 text-down hover:bg-down/20"
        : "border-muted/40 text-fg hover:border-accent hover:text-accent";
  return `${base} ${direction}`;
}
